// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

// Main component
import App from './App';

// Routing
import router from './router';

// UI library
import ElementUI from 'element-ui';

// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/reset.css';
import 'element-ui/lib/theme-chalk/display.css';
import './scss/element-variables.scss';

// carousel
import VueCarousel from 'vue-carousel';

// Http Client
import axios from 'axios';

// Store Management
import Vuex from 'vuex';

import store from './store'

// Utils
import _ from 'lodash';
// Time
import moment from 'moment';
// Page scrolling
import VueScrollTo from 'vue-scrollto';

// Lang
// import VueI18n from 'vue-i18n';
import i18n from './lang/lang';

// Google Analytics
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';

import * as VueGoogleMaps from 'vue2-google-maps';


import Geocoder from "@mariopando/vue2-geocoder";

// Font Awesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import fontawesome from '@fortawesome/fontawesome';

// import '@fortawesome/free-brands-svg-icons'
import { faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

library.add(faFacebook, faInstagram, faTwitter, faGlobe);
// fontawesome.library.add(faFacebookF, faInstagram, faTwitter);

// fontawesome.config = {
//   autoAddCss: false,
// };

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Geocoder, {
  googleMapsApiKey: 'AIzaSyC6nIYo-qa4RRH-IRxTxa9Y5a_8MvJ3At8',
});

import Vuebar from 'vuebar';
Vue.use(Vuebar);

Vue.use(VueAnalytics, {
  id: 'UA-127329468-1',
  router,
});
Vue.use(VueGtm, {
  id: 'GTM-K7R4H6P',
  enabled: true,
  debug: true,
  vueRouter: router,
});
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(VueScrollTo);
Vue.use(VueCarousel);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC6nIYo-qa4RRH-IRxTxa9Y5a_8MvJ3At8',
    libraries: 'places, visualization',
    // v: '3.26',
  },
  // Demonstrating how we can customize the name of the components
  // installComponents: false,
});
// Vue.use(VueI18n);

// Google Maps credentials
// load({
//   key: 'AIzaSyC6nIYo-qa4RRH-IRxTxa9Y5a_8MvJ3At8',
// });

// Vue settings
Vue.config.productionTip = false;

// router.beforeEach((to, from, next) => {
//   const nearestWithLang = to.matched.slice().reverse().find(r => r.meta && r.meta.lang);
//
//   if (nearestWithLang.meta.lang) {
//     i18n.locale = nearestWithLang.meta.lang;
//   }
//
//   next();
// });

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
  mounted(){
    document.dispatchEvent(new Event('app.rendered'));
  },
});



// WEBPACK FOOTER //
// ./src/main.js